import { useEffect, useRef, useState } from "react";
import { KIDDEE_PAGE } from "@/constants/testIds";

const reducedMotion = () => window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

export const KiddeeHero = () => {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  useEffect(() => {
    const v = ref.current;
    if (!v || reducedMotion()) return;
    v.playbackRate = 0.6;
    v.play().then(() => setPlaying(true)).catch(() => {});
  }, []);
  const toggle = () => {
    const v = ref.current;
    if (!v) return;
    if (v.paused) {
      v.playbackRate = 0.6;
      v.play().then(() => setPlaying(true)).catch(() => {});
    } else {
      v.pause();
      setPlaying(false);
    }
  };
  return (
    <section data-testid={KIDDEE_PAGE.hero} className="bg-[#FDFBF7]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-10 sm:py-16 grid lg:grid-cols-12 gap-8 lg:gap-12 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#E06D44]">The Kiddee Collection</p>
          <h1 data-testid={KIDDEE_PAGE.title} className="font-heading mt-4 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05]">
            Kiddee Approved. Tail-Wagging Fun.
          </h1>
          <p className="mt-5 text-base sm:text-lg text-stone-600 max-w-md">
            Discover playful, engaging toys selected for dogs who love to move, explore, and have fun.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-4">
            <a href="#picks" data-testid={KIDDEE_PAGE.heroCta} className="min-h-[48px] inline-flex items-center px-7 rounded-full bg-[#E06D44] text-white font-bold tracking-wide hover:bg-[#C95B33] transition-colors">
              SHOP KIDDEE'S PICKS
            </a>
            <div className="flex items-center gap-3">
              <img src="/media/kiddee/1.jpg" alt="Kiddee the rat terrier smiling" width="48" height="48" className="w-12 h-12 rounded-full object-cover border-2 border-white shadow" />
              <p className="text-sm text-stone-600 leading-tight">Picked by Kiddee,<br />our real rat terrier tester</p>
            </div>
          </div>
        </div>
        <div className="lg:col-span-7 order-1 lg:order-2 relative">
          <video
            ref={ref}
            data-testid={KIDDEE_PAGE.heroVideo}
            src="/media/kiddee.mp4?v=2"
            poster="/media/kiddee-video-poster.jpg?v=2"
            muted
            loop
            playsInline
            preload="metadata"
            aria-label="Kiddee leaping into the swimming pool in slow motion"
            className="w-full aspect-[3/2] object-cover rounded-[2rem] bg-[#1C1917]"
          />
          <button
            data-testid={KIDDEE_PAGE.heroVideoToggle}
            onClick={toggle}
            className="absolute bottom-4 right-4 min-h-[44px] px-4 rounded-full bg-black/55 text-white text-sm font-medium backdrop-blur-md hover:bg-black/70 transition-colors"
          >
            {playing ? "Pause video" : "Play video"}
          </button>
        </div>
      </div>
    </section>
  );
};
